import React from 'react';
import { OutlinedButton, RegularButton } from 'pg-ui-library';
import { t } from 'i18next';
import { ModalContainer, ModalContent } from './styles';

interface ConfirmationModalProps {
  isOpen: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

// eslint-disable-next-line react/prop-types
const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ isOpen, message, onConfirm, onCancel }) => (
  <ModalContainer isOpen={isOpen}>
    <ModalContent>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <b>{t('global.form.warning')}</b>
      </div>
      <p style={{ textAlign: 'center' }}>{message}</p>
      <OutlinedButton onClick={onCancel}>{t('global.form.cancel')}</OutlinedButton>
      <RegularButton onClick={onConfirm}>{t('global.form.confirm')}</RegularButton>
    </ModalContent>
  </ModalContainer>
);

export default ConfirmationModal;
